import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const { BRAZE_API, BRAZE_SDK_ENDPOINT, BRAZE_SESSION_TIMEOUT_IN_SECONDS } = publicRuntimeConfig;

export { BRAZE_API, BRAZE_SDK_ENDPOINT };
export const EXPIRED_AUTH_ERROR_CODE = 22;
export const SESSION_TIMEOUT_IN_SECONDS = Number.parseInt(BRAZE_SESSION_TIMEOUT_IN_SECONDS) || 60 * 30; // 30 minutes in seconds
